import AppBar from './AppBar';
import Content from './Content';
import Header from './Header';
import Footer from './Footer';

export default Object.assign(Header, {AppBar, Content, Footer});
